/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

import * as uxstackpb from '@uxstack/sdk-proto-js/uxstack/sdk/v1/sdk_pb';
import { EventPayload } from './payload';
import { Logger } from '../../logger';

export class PagePerformancePayload extends uxstackpb.PerformancePayload implements EventPayload {
  constructor() {
    const entries = performance.getEntries().map((entry) => {
      if (entry instanceof PerformanceNavigationTiming) {
        return new uxstackpb.PerformanceEntry({
          entry: {
            value: new uxstackpb.PerformanceNavigationTiming(entry.toJSON()),
            case: 'navigationTiming',
          },
        });
      } else if (entry instanceof PerformanceMark) {
        return new uxstackpb.PerformanceEntry({
          entry: {
            value: new uxstackpb.PerformanceMark(entry.toJSON()),
            case: 'mark',
          },
        });
      } else if (entry instanceof PerformanceMeasure) {
        return new uxstackpb.PerformanceEntry({
          entry: {
            value: new uxstackpb.PerformanceMeasure(entry.toJSON()),
            case: 'measure',
          },
        });
      } else if (entry instanceof PerformanceEventTiming) {
        return new uxstackpb.PerformanceEntry({
          entry: {
            value: new uxstackpb.PerformanceEventTiming(entry.toJSON()),
            case: 'eventTiming',
          },
        });
      } else if (entry instanceof PerformancePaintTiming) {
        return new uxstackpb.PerformanceEntry({
          entry: {
            value: new uxstackpb.PerformancePaintTiming(entry.toJSON()),
            case: 'paintTiming',
          },
        });
      } else if (entry instanceof PerformanceResourceTiming) {
        return new uxstackpb.PerformanceEntry({
          entry: {
            value: new uxstackpb.PerformanceResourceTiming(entry.toJSON()),
            case: 'resourceTiming',
          },
        });
      } else if (entry instanceof VisibilityStateEntry) {
        return new uxstackpb.PerformanceEntry({
          entry: {
            value: new uxstackpb.VisibilityState(entry.toJSON()),
            case: 'visibilityState',
          },
        });
      } else {
        Logger.warn('Unsupported performance entry', entry);
      }
    });

    super({
      entries: entries,
    });
  }

  public toPayload(): typeof uxstackpb.EventMessage.prototype.payload {
    return {
      case: 'performance',
      value: this,
    };
  }
}
